import styled from 'styled-components';
import { createGlobalStyle } from 'styled-components';

// Global styles for search container (CSS-in-JS)
export const SearchContainerStyles = createGlobalStyle`
    .search-container .search-label {
        width: 100% !important;
        margin-bottom: 0 !important;
        flex: 1 1 0% !important;
        min-width: 0 !important;
    }
    
    .search-container .search_field input {
        border: none !important;
        outline: none !important;
        box-shadow: none !important;
        flex: 1 1 0% !important;
        min-width: 0 !important;
        width: 100% !important;
        font-size: 16px !important;
        font-family: Inter !important;
        font-weight: 400 !important;
        color: #101828 !important;
        background: transparent !important;
        height: 100% !important;
        min-height: 46px !important;
        line-height: 24px !important;
        padding: 11px 0 11px 0 !important;
        margin: 0 !important;
        position: relative !important;
        z-index: 1 !important;
    }
    
    .search-container .search_field input:focus,
    .search-container .search_field input:active,
    .search-container .search_field input:focus-visible {
        border: none !important;
        outline: none !important;
        box-shadow: none !important;
    }
    
    .search-container .search_field input::placeholder {
        opacity: 0 !important;
    }
    
    .search-container .search_field__fake-placeholder {
        position: absolute;
        left: 42px;
        top: 50%;
        transform: translateY(-50%);
        color: #98A2B3;
        font-family: Inter;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        pointer-events: none;
        z-index: 1;
        transition: opacity 0.2s ease;
    }
    
    .search-container .search_field__fake-placeholder.hidden {
        opacity: 0;
        pointer-events: none;
    }
    
    .search-container .serach_field-area {
        flex-shrink: 0 !important;
        width: auto !important;
        max-width: none !important;
    }
    
    .search-container .react-datepicker-wrapper {
        flex-shrink: 0 !important;
    }
    
    .search-container .search_field > div {
        width: 100% !important;
        min-width: 0 !important;
    }
`;

// Container components
export const TableContainer = styled.div`
    position: relative;
`;

export const ContentTableWrapper = styled.div`
    width: 100%;
`;

// Search section
export const SearchContainer = styled.div`
    gap: 12px;
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
    margin-left: 0;
`;

export const SearchFieldArea = styled.div`
    flex-shrink: 0;
    width: auto;
`;

export const SearchInner = styled.div`
    width: 100%;
`;

export const SearchField = styled.div`
    display: flex;
    width: 320px;
    height: 46px;
    padding: 0;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    border-radius: 10px;
    border: 1px solid #D0D5DD;
    background: #FFF;
    position: relative;
`;

export const SearchFieldInner = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 0 14px;
    gap: 8px;
    min-width: 0;
    position: relative;
`;

export const SearchIconContainer = styled.div`
    flex-shrink: 0;
    z-index: 2;
    position: absolute;
    left: 14px;
`;

export const SearchInputContainer = styled.div`
    flex: 1 1 0%;
    min-width: 0;
    width: 100%;
    position: relative;
`;

export const FakePlaceholder = styled.span`
    position: absolute;
    left: 42px;
    top: 50%;
    transform: translateY(-50%);
    color: #98A2B3;
    font-family: Inter;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    pointer-events: none;
    z-index: 1;
    transition: opacity 0.2s ease;
`;

export const ClearButton = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    z-index: 2;
`;

// Date picker wrapper
export const DatePickerWrapper = styled.div`
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 8px;
    position: relative;
`;

export const DatePickerClearButton = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    z-index: 2;
    padding: 4px;
`;

export const ClearFiltersButton = styled.button`
    display: flex;
    padding: 12px 10px;
    align-items: center;
    gap: 5px;
    border-radius: 10px;
    border: 1px solid #D0D5DD;
    background: #FFF;
    cursor: pointer;
    color: #667085;
    text-align: center;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 21px;
    white-space: nowrap;
    height: 46px;
    margin-left: 16px;
    position: relative;
    &:before {
        content: "" !important;
        width: 1px !important;
        height: 32px !important;
        background: #D0D5DD !important;
        position: absolute;
        left: -16px;
    }
    &:hover {
        opacity: 0.9;
    }
    
    svg {
        width: 16px;
        height: 16px;
        flex-shrink: 0;
    }
`;

// Filter container spacing
export const FilterSpacer = styled.div`
    width: 60px;
`;

// Selection row renderer
export const SelectionRowWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
`;

// Pagination
export const PaginationWrapper = styled.div`
    margin-left: auto;
    display: flex;
    justify-content: flex-end;
    margin-top: 1rem;
`;

// Column formatters
export const StatusCellWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
`;

export const ActionsCellWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

